const GET_CROWDSALE_DATA = 'crowdsale/getCrowdsaleData';
const BUY_TOKENS = 'crowdsale/buyTokens';
const APPROVE = 'crowdsale/approve';

export const actionTypes = {
  GET_CROWDSALE_DATA,
  BUY_TOKENS,
  APPROVE,
} as const;
